var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiCreateClientHotlineRequestInterviewCancel, apiUpdateClientHotlineRequestInterviewCancel, } from '@/actions/ClientHotlineRequestInterviewActions';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * クライアント：ホットライン面談キャンセル送信処理
 * @param options
 * @returns
 */
export const useHotlineRequestInterviewCancelClient = (options) => {
    const { dispatch, id, onSubmitCallback } = options;
    /**
     * キャンセル送信処理
     */
    const onSubmitCancel = useCallback((requestId, interviewId, formValues) => __awaiter(void 0, void 0, void 0, function* () {
        const request = {
            json: {
                cancel_reason: formValues.cancelReason,
            },
            path: {
                hotline_request_id: requestId,
                id,
            },
        };
        // 面談IDの有無に応じて実行するアクションを切り替え
        const action = interviewId
            ? apiUpdateClientHotlineRequestInterviewCancel(Object.assign(Object.assign({}, request), { path: Object.assign(Object.assign({}, request.path), { hotline_request_interview_id: interviewId }) }), {})
            : apiCreateClientHotlineRequestInterviewCancel(request, {});
        yield wrapDispatch(dispatch, action);
        yield (onSubmitCallback === null || onSubmitCallback === void 0 ? void 0 : onSubmitCallback());
    }), [dispatch, id, onSubmitCallback]);
    return {
        onSubmitCancel,
    };
};
